module.exports = __webpack_public_path__ + "logo.png?57817059fdc7171e53be53879ce4f978";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 57
// module chunks = 0